import styled from "styled-components";
import { useParams } from "react-router-dom";
import SideBar from "../../../../components/Sidebar";
import AccountTypes from "./AccountTypes";
import AccountSections from "./AccountSections";
import AccountSectionCodes from "./AccountSectionCodes";
import { useEffect } from "react";

const StyledSystemStructure = styled.div`
    display: flex;
`;

function SystemStructure(props) {

    let defaultPath = '/systemstructure/';

    let defaultPagePath = 'accounttypes';
    let {subPagePath} = useParams();

    let items = [
        {text: 'Account types', path: 'accounttypes'},
        {text: 'Account sections', path: 'accountsections'},
        {text: 'Account section codes', path: 'accountsectioncodes'},
    ];

    let loadedPage = false;
    useEffect(() => {
        if (!loadedPage) {
            loadedPage = true;
            props.setSmallPageTitle('');
        }
    });

    return (
        <StyledSystemStructure>
            <SideBar title={'System structure'} items={items} defaultPath={defaultPath} selectedSubPagePath={subPagePath ? subPagePath : defaultPagePath} {...props}></SideBar>
            {(!subPagePath || subPagePath === '' || subPagePath === 'accounttypes') && <AccountTypes {...props}></AccountTypes>}
            {subPagePath === 'accountsections' && <AccountSections {...props}></AccountSections>}
            {subPagePath === 'accountsectioncodes' && <AccountSectionCodes {...props}></AccountSectionCodes>}
        </StyledSystemStructure>
    )
}

export default SystemStructure;